// scroll bar
import 'simplebar/src/simplebar.css';
// editor
import 'react-quill/dist/quill.snow.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// next
import React, { useState, useEffect } from 'react';
import App from 'next/app';
import Head from 'next/head';
import Router from 'next/router';
import dynamic from 'next/dynamic';
import getConfig from 'next/config';
import { CacheProvider } from '@emotion/react';

// material
import { NoSsr } from '@mui/material';
// contexts
import { SettingsProvider } from 'src/contexts/SettingsContext';
import { CollapseDrawerProvider } from 'src/contexts/CollapseDrawerContext';
// theme
import ThemeConfig from 'src/theme';
import GlobalStyles from 'src/theme/globalStyles';
// utils
import createEmotionCache from 'src/utils/createEmotionCache';
// components
import RtlLayout from 'src/components/RtlLayout';
import ProgressBar from 'src/components/ProgressBar';
import LoadingScreen from 'src/components/LoadingScreen';
import ThemePrimaryColor from 'src/components/ThemePrimaryColor';
import { SnackbarProvider } from 'notistack';

// redux ----------------------------------------------------------------
import makeStore from '../store';
import withRedux from 'next-redux-wrapper';
// ----------------------------------------------------------------------

import moment from 'moment';
import 'moment/locale/th';
moment.locale('th');

//#region JNZ Auth ======================================================

import { JnzAuthWrapper } from '@root/jnzAuthWrapper';
import { jnzAuthConfig, isDebug } from '@root/config/config.next';

const {
  cookiesDomain,
  jnzAuthActive,
  jnzWebToken,
  jnzAuthToken,
  jnzServiceToken,
  jnzCompanyToken,
  redirectIfNoCompany,
  redirectIfAuthenticated,
  redirectIfNotAuthenticated } = jnzAuthConfig;

//#endregion JNZ Auth ====================================================

const Settings = dynamic(() => import('src/components/settings'), { ssr: false });

const clientSideEmotionCache = createEmotionCache();

const { publicRuntimeConfig } = getConfig();

if (!publicRuntimeConfig.IS_DEBUG) {
  console.log = () => { };
  console.info = () => { };
  console.warn = () => { };
  console.error = () => { };
}

const isAcitiveSettingMenu = false;
const isActiveLoadingScreen = true;

class MyApp extends App {

  static async getInitialProps({ Component, ctx }) {

    const pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {};

    return { pageProps };
  }



  render() {
    const { Component, emotionCache = clientSideEmotionCache, pageProps } = this.props;

    /*console.log("process.env : ", { pageProps });*/

    // console.log("process.env : ", {
    //   cookiesDomain,
    //   jnzAuthActive,
    //   jnzAuthToken,
    //   jnzServiceToken,
    //   jnzCompanyToken,
    //   redirectIfNoCompany,
    //   pageProps
    // })

    return (
      <SettingsProvider>
        <CollapseDrawerProvider>
          <CacheProvider value={emotionCache}>
            <Head>
              <meta
                name="viewport"
                content="initial-scale=1, width=device-width"
              />
            </Head>
            <ThemeConfig>
              <ThemePrimaryColor>
                <RtlLayout>
                  <NoSsr>
                    {(isAcitiveSettingMenu) && <Settings />}
                  </NoSsr>
                  <GlobalStyles />
                  <ProgressBar />
                  <NoSsr>
                    {(isActiveLoadingScreen) && <LoadingScreen />}
                  </NoSsr>
                  <SnackbarProvider>
                    <JnzAuthWrapper {...this.props} />
                  </SnackbarProvider>
                </RtlLayout>
              </ThemePrimaryColor>
            </ThemeConfig>
          </CacheProvider>
        </CollapseDrawerProvider>
      </SettingsProvider>
    );
  }

}

export default withRedux(makeStore, { debug: isDebug })(MyApp);
